interface ErrorPopupProps {
  title: string;
  message: string;
  onDismiss: () => void;
}

export default function ErrorPopup({ title, message, onDismiss }: ErrorPopupProps) {
  return (
    <div className="fixed inset-0 bg-black/90 z-[100] flex items-center justify-center p-4">
      <div className="bg-surface border border-border rounded-xl p-6 max-w-sm w-full animate-fade-in">
        <div className="text-center">
          <div className="w-16 h-16 rounded-full bg-error/20 flex items-center justify-center mx-auto mb-4">
            <span className="text-error text-4xl font-bold">X</span>
          </div>
          <h2 className="text-xl font-bold text-error mb-2 whitespace-pre-line">{title}</h2>
          <p className="text-text-secondary mb-6">{message}</p>
          <button
            onClick={onDismiss}
            className="btn-primary bg-surface-raised border border-border text-text-primary font-semibold"
          >
            UNDERSTOOD
          </button>
        </div>
      </div>
    </div>
  );
}
